module.exports = __webpack_public_path__ + "59e21b5ee0ffdac6f899e8ef46cb3175.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-SemiBold.ttf
 ** module id = 908
 ** module chunks = 9
 **/